import { useEffect, useRef } from 'react';
import api from '../api/axios';

/**
 * 患者の在席ハートビート。
 * 有効な間、一定間隔で POST /presence/ping を送り、医師側の在席ランプ（緑）を点灯させる。
 * 認証済みの患者ページ（マイページ・診療室など）でのみ使用する。失敗は無視（表示に影響しない）。
 */
export function usePresenceHeartbeat(opts?: {
  enabled?: boolean;
  source?: string;
  intervalMs?: number;
}) {
  const enabled = opts?.enabled ?? true;
  const source = opts?.source ?? 'ping';
  const intervalMs = opts?.intervalMs ?? 45000; // 45秒ごと（オンライン窓は 6 分なので余裕）
  const cancelled = useRef(false);

  useEffect(() => {
    if (!enabled) return;
    cancelled.current = false;

    const ping = () => {
      // 未ログインなら送らない（401 連発と誤ログアウトを防ぐ）
      if (!localStorage.getItem('token')) return;
      // skipAuthRedirect: 401 でもグローバルなログアウト/リダイレクトを起こさない（純粋な背景ハートビートのため）
      api.post('/presence/ping', null, { params: { source }, skipAuthRedirect: true } as any).catch(() => {});
    };

    ping(); // マウント直後に即 ping
    const id = window.setInterval(() => {
      if (!cancelled.current) ping();
    }, intervalMs);

    // タブが再表示されたら即 ping（バックグラウンドで interval が絞られるため）
    const onVis = () => {
      if (document.visibilityState === 'visible' && !cancelled.current) ping();
    };
    document.addEventListener('visibilitychange', onVis);

    return () => {
      cancelled.current = true;
      window.clearInterval(id);
      document.removeEventListener('visibilitychange', onVis);
    };
  }, [enabled, source, intervalMs]);
}

export default usePresenceHeartbeat;
